var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-grade"},[_c('span',{staticClass:"c-grade__header"},[_vm._v("年级分布")]),_c('div',{staticClass:"c-grade__bgc"},[_c('div',{staticClass:"grade-distribute"}),(!_vm.show)?_c('EmptyLearning'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }